"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_2 = require("@fluentui/react");
var react_redux_1 = require("react-redux");
var reducers_1 = require("../../reducers");
require("./Forms.scss");
require("./CustomCheckbox.scss");
var connector = react_redux_1.connect(reducers_1.ComponentEtaMapStateToProps);
var CustomCheckbox = function (props) {
    var className = props.className, readOnly = props.readOnly, currentLang = props.currentLang, toolTip = props.toolTip;
    var useClassName = clsx_1.default(className, readOnly ? 'eta-cCheckboxReadOnly' : '', currentLang.isRtl ? 'rtlFlag' : 'ltrFlag');
    return react_1.default.createElement(react_2.Checkbox, __assign({}, props, { title: toolTip, className: useClassName }));
};
exports.default = connector(CustomCheckbox);
//# sourceMappingURL=CustomCheckbox.js.map